module.exports = __webpack_public_path__ + "img/section3_m.e31f018f.jpg";